import { ModuleWithProviders, NgModule } from '@angular/core';
import { GoliathContactsCRMFeatureModule } from '@digiwall/goliath-contacts/config';
import {
  GoliathDocumentsDeliveryFeatureModule,
  GoliathDocumentsPurchaseFeatureModule,
  GoliathDocumentsSaleFeatureModule,
  GoliathDocumentsStockFeatureModule,
  GoliathDocumentsSubscriptionFeatureModule,
} from '@digiwall/goliath-documents/config';
import {
  GoliathProductsProductionFeatureModule,
  GoliathProductsStockFeatureModule,
} from '@digiwall/goliath-products/config';

@NgModule({
  imports: [
    GoliathProductsStockFeatureModule.forRoot(),
    GoliathDocumentsStockFeatureModule.forRoot(),
    GoliathDocumentsSubscriptionFeatureModule.forRoot(),
    GoliathProductsProductionFeatureModule.forRoot(),
    GoliathContactsCRMFeatureModule.forRoot(),
    GoliathDocumentsSaleFeatureModule.forRoot(),
    GoliathDocumentsPurchaseFeatureModule.forRoot(),
    GoliathDocumentsDeliveryFeatureModule.forRoot(),
  ],
})
export class GoliathFeaturesConfigModule {
  static forRoot(): ModuleWithProviders<GoliathFeaturesConfigModule> {
    return {
      ngModule: GoliathFeaturesConfigModule,
    };
  }
}
